/**
 * /devhub — DevHub layout (ControlPlane operator cockpit). Surface Layer (/01).
 *
 * REQ-001.91 DevHub UI rebuild · Phase 1. The layout for the new operator IA: the routePolicy root
 * guard + the per-page useEntitlements self-guard gate access to the control plane; this renders the
 * matched area child (home / runtime / ai / governance / resources / release / audit) via <Outlet/>.
 * The home content is the index route (devhub.index.tsx). The legacy control-plane.tsx stays mounted
 * as fallback until the Phase-5 cutover.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/devhub')({ component: DevHubLayout });

function DevHubLayout() {
  return <Outlet />;
}
